/**
 * This is the image Lazy-loader service
 */

const $device = [ function () {
    // this.mobile = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent);
    // this.tablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent);

    this.run = function() {
        return {
            label: window.innerWidth < 768 ? 'mobile' : ( window.innerWidth <= 1023 ? 'tablet' : 'desktop'),
            mobile: window.innerWidth < 768,
            tablet: window.innerWidth >= 768 && window.innerWidth <= 1023,
            desktop: window.innerWidth >= 1024,
            width: window.innerWidth,
            height: window.innerHeight,
            ios: (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream),
            android: (/android/.test(navigator.userAgent)),
            orientation: window.innerWidth < window.innerHeight ? 'portrait' : 'landscape',
            touch: (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch)) || (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)),
            browser: {
                chrome: (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !!window.chrome) || /CriOS/.test(navigator.userAgent),
                safari: /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor),
            }
        }
    }
}];

export default $device;
